import React from "react";
import { useNavigate } from "react-router-dom";

function fmt(val, decimals = 2) {
  if (val === null || val === undefined) return "-";
  if (typeof val === "number") return val.toFixed(decimals);
  return val;
}

// Show fractional shares with up to 6 dp, stripping trailing zeros
function fmtQuantity(val) {
  if (val === null || val === undefined) return "-";
  return parseFloat(val.toFixed(6)).toString();
}

// Green for gains, red for losses; default colour for null/zero.
function gainClass(val) {
  if (val === null || val === undefined || val === 0) return undefined;
  return val > 0 ? "text-success" : "text-danger";
}

// Renders "total (unrealised)" when the two differ (i.e. there are realized
// gains), otherwise just the total. `suffix` appends e.g. "%" to each figure.
function fmtWithUnrealized(total, unrealized, suffix = "") {
  if (total === null || total === undefined) return "-";
  const totalStr = `${fmt(total)}${suffix}`;
  if (unrealized === null || unrealized === undefined || Math.abs(total - unrealized) < 0.005) {
    return totalStr;
  }
  return `${totalStr} (${fmt(unrealized)}${suffix})`;
}

export function PortfolioGridItem({ row }) {
  const {
    ticker, exchange, price, quantity, value, capitalGain, capitalGainUnrealized,
    income, totalReturn, totalReturnUnrealized, currency, return: ret, returnUnrealized,
  } = row;
  const navigate = useNavigate();

  return (
    <tr>
      <th
        scope="row"
        onClick={() => navigate(`/portfolio/stocks/${ticker}`)}
        style={{ cursor: "pointer", textDecoration: "underline" }}
      >
        {ticker} | {exchange}
      </th>
      <td>{price === null ? "Fetching..." : fmt(price)}</td>
      <td>{fmtQuantity(quantity)}</td>
      <td>{value === null ? "-" : fmt(value)}</td>
      <td className={gainClass(capitalGain)}>{fmtWithUnrealized(capitalGain, capitalGainUnrealized)}</td>
      <td>{income === null ? "-" : fmt(income)}</td>
      <td className={gainClass(totalReturn)}>{fmtWithUnrealized(totalReturn, totalReturnUnrealized)}</td>
      <td>{currency}</td>
      <td className={gainClass(ret)}>{fmtWithUnrealized(ret, returnUnrealized, "%")}</td>
    </tr>
  );
}
